const DNT_STATUS_ENABLED = 1;
const DNT_STATUS_DISABLED = 2;
const DNT_STATUS_UNSUPPORTED = 3;

function _hasDNTStatusInfo() {
  return (window.doNotTrack != null) || (navigator.doNotTrack != null) || (navigator.msDoNotTrack != null) ||
    (window.external && 'msTrackingProtectionEnabled' in window.external);
}

function _getDNTStatus() {
  if (!_hasDNTStatusInfo()) return DNT_STATUS_UNSUPPORTED;

  if (['1', 'yes', 1].includes(window.doNotTrack)) return DNT_STATUS_ENABLED;
  if (['1', 'yes', 1].includes(navigator.doNotTrack)) return DNT_STATUS_ENABLED;
  if (['1', 'yes', 1].includes(navigator.msDoNotTrack)) return DNT_STATUS_ENABLED;

  if (window.external &&
    'msTrackingProtectionEnabled' in window.external &&
    window.external.msTrackingProtectionEnabled()) return DNT_STATUS_ENABLED;

  return DNT_STATUS_DISABLED;
}

export function isDNTEnabled() {
  return _getDNTStatus() === DNT_STATUS_ENABLED;
}
